import { Controller } from '@hotwired/stimulus'
import { emit } from '../lib/events'

export default class extends Controller {
  connect() {
    this.coverImageInput = document.querySelector('input[type="file"][name="collection[cover_image]"]')
  }

  async selectProduct(event) {
    try {
      // Get the image URL from the clicked element
      const imageElement = event.currentTarget.querySelector('img')
      const key = imageElement.dataset.key
      const imageUrl = `/image_proxy/${key}`

      // Fetch the image as a blob
      const response = await fetch(imageUrl)
      const blob = await response.blob()

      // Create a File object from the blob
      const fileName = `${key}.${this.getFileExtension(imageUrl)}`
      const file = new File([blob], fileName, { type: this.getMimeType(imageUrl) })

      // Create a FileList-like object (with the necessary properties of a FileList)
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)

      // Assign the FileList-like object to the file input
      if (this.coverImageInput) {
        this.coverImageInput.files = dataTransfer.files
        this.coverImageInput.dispatchEvent(new Event('change', { bubbles: true }))

        this.closeModal()
      }
      else {
        console.error('Cover image input not found')
      }
    }
    catch (error) {
      console.error('Error selecting product image:', error)
    }
  }

  closeModal() {
    emit('closeSelectFromUploadsModal', { bubbles: true })
  }

  getFileExtension(url) {
    // Extract file extension from URL or default to jpg
    const match = url.match(/\.([^.]+)$/)
    return match ? match[1].toLowerCase() : 'jpg'
  }

  getMimeType(url) {
    const ext = this.getFileExtension(url)
    const mimeTypes = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      webp: 'image/webp',
    }

    return mimeTypes[ext] || 'image/jpeg'
  }
}
